import React, { useState, useRef } from "react";
import { FaArrowDown } from "react-icons/fa";

const ClickOrHoldButton = ({ onClick, onHold }) => {
  const [isHolding, setIsHolding] = useState(false);
  const [progress, setProgress] = useState(0);
  const timerRef = useRef(null);
  const clickRef = useRef(false); // Usado para rastrear se foi um clique ou um hold

  const handleStart = (e) => {
    e.preventDefault();
    setIsHolding(true);
    clickRef.current = true;

    let startTime = Date.now();

    timerRef.current = setInterval(() => {
      const elapsedTime = Date.now() - startTime;
      const newProgress = Math.min((elapsedTime / 1000) * 100, 100); // 2 segundos
      setProgress(newProgress);

      if (newProgress === 100) {
        clearInterval(timerRef.current);
        setIsHolding(false);
        clickRef.current = false;
        onHold();
      }
    }, 10);
  };

  const handleEnd = () => {
    clearInterval(timerRef.current);

    if (clickRef.current && progress < 100) {
      onClick();
    }

    setProgress(0);
    setIsHolding(false);
    clickRef.current = false;
  };

  return (
    <div className="flex flex-col items-center mr-2 md:-mr-2">
      <div
        className="relative w-16 h-16 flex items-center justify-center cursor-pointer"
        onMouseDown={handleStart} // Suporte para desktop
        onMouseUp={handleEnd} // Suporte para desktop
        onMouseLeave={handleEnd} // Cancela ao sair do botão no desktop
        onTouchStart={handleStart} // Suporte para dispositivos móveis
        onTouchEnd={handleEnd} // Suporte para dispositivos móveis
        onContextMenu={(e) => e.preventDefault()} 
      >
        <svg className="absolute w-full h-full" viewBox="0 0 36 36">
          <circle
            cx="18"
            cy="18"
            r="16"
            fill="none"
            stroke="#e0e0e0"
            strokeWidth="4"
          />
          <circle
            cx="18"
            cy="18"
            r="16"
            fill="none"
            stroke="#4caf50"
            strokeWidth="4"
            strokeDasharray="100"
            strokeDashoffset={100 - progress}
            strokeLinecap="round"
            transform="rotate(-90 18 18)"
          />
        </svg>
        <button
          className="w-12 h-12 rounded-full bg-gray-500 text-white font-bold shadow-lg flex justify-center items-center"
        >
          <FaArrowDown fontSize={20} />
        </button>
      </div>
      <div className="text-2xs mt-1 pointer-events-none hidden md:block">
        Segure para descer tudo
      </div>
    </div>
  );
};

export default ClickOrHoldButton;
